import { DOMPurifyI } from "dompurify";

export const sanitize = function (obj: any, sanitizer: DOMPurifyI, config={}) {
  if (typeof obj === "string") obj = sanitizer.sanitize(obj, config);
  else {
    for (const key of Object.keys(obj)) {
      if (typeof obj[key] === "string") obj[key] = sanitizer.sanitize(obj[key], config);
      else if (typeof obj[key] === "object" && obj[key] !== null) {
        sanitize(obj[key], sanitizer, config);
      }
    }
  }
  return obj;
}

export const setDomPurifyIframeValidationHook = (sanitizer: DOMPurifyI, srcRegexPattern: RegExp) => {
  sanitizer.addHook('uponSanitizeElement', (currentNode: any) => {
    if (currentNode.nodeName.toLowerCase() === 'iframe') {
      // remove iframe if src is not in srcRegexPattern
      if (!srcRegexPattern.test(currentNode.getAttribute('src'))) {
        currentNode.remove();
        return;
      }
      // remove iframe children 
      if (currentNode.innerHTML) currentNode.innerHTML = '';
    }

    return currentNode;
  });
};
